import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { MasterKushStrainIndexCardStackContentViewModel } from './master-kush-strain-index-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { MasterKushStrainCardData } from '../../../../../../../models/print-cards/master-kush-strain-card-data';

@Component({
  selector: 'app-master-kush-strain-index-card-content',
  templateUrl: './master-kush-strain-index-card-stack-content.component.html',
  styleUrls: ['./master-kush-strain-index-card-stack-content.component.scss'],
  providers: [MasterKushStrainIndexCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MasterKushStrainIndexCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: MasterKushStrainIndexCardStackContentViewModel,
    elementRef: ElementRef,
    renderer: Renderer2
  ) {
    super(viewModel, elementRef, renderer);
  }

  @Input() override data: MasterKushStrainCardData;
}
